import React, { createContext, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAdminEmails, updateEmailInvite, fetchCustomerList, syncUserTable as syncUserTableThunk } from '../../store/actions/adminActions';

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  return (
    <AdminContext.Provider value={{ isAdmin, setIsAdmin }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }

  const dispatch = useDispatch();
  const emails = useSelector((state) => state.admin.emails);
  const customerList = useSelector((state) => state.admin.customerList);
  const customerCount = useSelector((state) => state.admin.customerCount);
  const loading = useSelector((state) => state.admin.loading);
  const error = useSelector((state) => state.admin.error);

  const fetchEmails = () => dispatch(fetchAdminEmails());
  const updateEmailInviteFn = (payload) => dispatch(updateEmailInvite(payload));
  const fetchCustomerListFn = (params) => dispatch(fetchCustomerList(params));

  const syncUserTable = () => dispatch(syncUserTableThunk());

  return {
    isAdmin: context.isAdmin,
    setIsAdmin: context.setIsAdmin,
    emails,
    customerList,
    customerCount,
    loading,
    error,
    fetchEmails,
    updateEmailInvite: updateEmailInviteFn,
    syncUserTable,
    fetchCustomerList: fetchCustomerListFn,
  };
};